import {createSelector} from '@ngrx/store';
import {templateTagEntityAdapter as EntityAdapter, TemplateTagState as EntityState} from "./template-tag.state";
import {TemplateTag as Entity} from './template-tag.model';
import {AppState} from "src/app/store/app-store.state";

export const selectState = (state: AppState) => state.templateTag;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
  createSelector(selectAll, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) => createSelector(
  selectState,
  (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
);

export const currentEntityId = createSelector(selectState, (state: EntityState) => state.currentEntityId);

export const currentEntity = createSelector(selectState, (state: EntityState) => {
  return state.currentEntityId
    ? state.entities[state.currentEntityId]
    : undefined
});

export const getTagValuesByCategoryId = (templateCategoryId: number, isRequired?:boolean) => createSelector(
  selectState,
  (state: EntityState) => {
    const tags = state.templateTagValues?.[templateCategoryId] ?? [];
    return tags.filter(y => isRequired === undefined || y.isRequired === isRequired);
  }
);

export const totalPageable = createSelector(selectState, (state: EntityState) => state.currentPage.totalCount);
export const currentPage = createSelector(selectState, (state: EntityState) => state.currentPage.page);
export const currentSort = createSelector(selectState, (state: EntityState) => state.currentSort);
export const TemplateTagSelectors = {
  selectAll,
  selectById,
  isLoading,
  hasErrors,
  findByCorrelationId,
  currentEntity,
  currentEntityId,
  totalPageable,
  currentPage,
  currentSort,
  getTagValuesByCategoryId
};
